module.exports = __webpack_public_path__ + "img/avatar.f01bcd33.png";